import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useGetModuleQuery } from "@api/ModulesApi.ts";
import Loader from "@components/Loader.tsx";
import { ElementNotFound } from "@components/errors/ElementNotFound.tsx";
import { ModuleContext } from "@/contexts/ModuleContext";
import ModuleSummaryCard from "@components/modules/ModuleSummaryCard.tsx";
import { Stack } from "@mui/material";

export const Route = createFileRoute("/_dashboard/modules/$uuid")({
  beforeLoad: ({ params, location }) => {
    if (location.pathname === `/modules/${params.uuid}`) {
      throw redirect({
        to: "/modules/$uuid/$tab",
        params: { uuid: params.uuid, tab: "overview" },
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { uuid } = Route.useParams();
  const { data, isLoading } = useGetModuleQuery(uuid);

  if (isLoading) return <Loader />;
  if (!data) return <ElementNotFound />;

  return (
    <ModuleContext.Provider value={data}>
      <Stack spacing={2}>
        <ModuleSummaryCard module={data} />
        <Outlet />
      </Stack>
    </ModuleContext.Provider>
  );
}
